import React from 'react'
import { Skeleton } from '@/components/shadcn/skeleton'

export const ChartLoading: React.FC = () => {
  return (
    <div className="flex h-full flex-col">
      {/* Header with title and filter skeletons */}
      <div className="flex w-full flex-wrap items-center justify-between gap-4 border-b pb-4">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-6 w-48" /> {/* Title */}
          <Skeleton className="h-4 w-64" /> {/* Description */}
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-36" /> {/* Filter dropdown */}
          <Skeleton className="h-9 w-20" /> {/* Apply button */}
        </div>
      </div>

      {/* Chart area */}
      <div className="relative mt-6 flex h-full w-full flex-col">
        {/* Y-axis label and ticks */}
        <div className="absolute left-0 top-0 flex h-full w-10 flex-col justify-between py-4">
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-6" />
          <Skeleton className="h-4 w-7" />
          <Skeleton className="h-4 w-5" />
          <Skeleton className="h-4 w-8" />
        </div>

        {/* Main chart area */}
        <div className="ml-10 flex h-full w-full flex-col">
          {/* Chart content */}
          <div className="relative h-[calc(100%-40px)] w-full overflow-visible">
            {/* Grid lines */}
            <div className="h-full w-full">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="w-full border-t border-gray-100"
                  style={{
                    position: 'absolute',
                    top: `${i * 25}%`,
                    left: 0,
                  }}
                />
              ))}
            </div>

            {/* Bars - with fixed positioning and clear heights */}
            <div className="absolute bottom-0 left-0 flex w-full justify-around px-4" style={{ height: '100%' }}>
              {[...Array(4)].map((_, i) => {
                const barHeight = 10 + i * 20
                return (
                  <div
                    key={i}
                    className="relative flex flex-col items-center justify-end"
                    style={{ width: '15%', height: '100%' }}
                  >
                    <Skeleton
                      className="w-full rounded-b-none rounded-t-md"
                      style={{
                        height: `${barHeight}%`,
                        minHeight: '20px',
                        opacity: 0.8, // Ensure visibility
                      }}
                    />
                  </div>
                )
              })}
            </div>
          </div>

          {/* X-axis labels */}
          <div className="flex h-10 justify-around py-2">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="h-4 w-8" />
            ))}
          </div>
        </div>

        {/* Legend */}
        <div className="mt-4 flex justify-center gap-4">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>
    </div>
  )
}
